import "bootstrap";
import "./modules/aos";
import "./modules/swiper";
import "./modules/navbar";
import "./modules/animation";
import "./modules/copy-url";
import "./modules/modal";
